import { useThemeColors } from '@codezo/theme';
import { Box } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { HeaderNavigation } from '../../shared/components/HeaderNavigation';

export function PlatformLayout() {
	const colors = useThemeColors();

	return (
		<Box
			style={{
				display: 'flex',
				flexDirection: 'column',
				height: '100vh',
				backgroundColor: colors.background,
			}}
		>
			{/* Header Navigation */}
			<HeaderNavigation />

			{/* Main content area */}
			<Box
				style={{
					flex: 1,
					backgroundColor: colors.surface,
					display: 'flex',
					flexDirection: 'column',
					overflow: 'hidden',
				}}
			>
				<Outlet />
			</Box>
		</Box>
	);
}
